<template>
  <div class="portada-xv" ref="rootRef" aria-label="Portada de XV">
    <!-- FLORES DECORATIVAS -->
    <img src="@/assets/florcoco1.png" class="flor flor-1" alt="" />
    <img src="@/assets/florcoco2.png" class="flor flor-2" alt="" />
    <img src="@/assets/flor3.png" class="flor flor-3" alt="" />

    <!-- NUEVAS FLORES -->
    <img src="@/assets/flor1.png" class="flor flor-4" alt="" />
    <img src="@/assets/flor4.png" class="flor flor-5" alt="" />
    <img src="@/assets/flor3.png" class="flor flor-6" alt="" />

    <!-- BOLA DISCO GIRANDO -->
    <img src="@/assets/disco.png" class="bola bola-izquierda" alt="" />

    <!-- IMAGEN CON RECORTE -->
    <div class="imagen-xv-wrapper">
      <img src="@/assets/3-_1__11zon (1).webp" class="imagen-xv" alt="Foto protagonista" />
    </div>

    <!-- TEXTO PRINCIPAL -->
    <section class="texto-xv">
      <p class="frase-bendicion">
        Con la bendición de Dios <br />
        y de mis padres<br />
      </p>

      <!-- Contenedor para asegurar alineación si es necesario, 
           o simplemente asegurar que los tres elementos se animen en orden -->
      <div class="nombres-contenedor">
        <h1 class="nombre-protagonista"> Marine </h1>
        <span class="ampersand">&amp;</span>
        <h1 class="nombre-protagonista"> Cesar </h1>
      </div>

      <div class="separador-elegante" aria-hidden="true"></div>

      <p class="parrafo-presentacion">
        Hay momentos que definen nuestra vida, quedando grabados en el alma y la memoria.
        Hoy experimento uno de esos instantes especiales y quiero compartirlo con quienes
        tienen un lugar en mi corazón.
      </p>
    </section>
  </div>
</template>

<script>
import { onMounted, ref, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'PortadaArley',
  setup() {
    const rootRef = ref(null)

    onMounted(async () => {
      await nextTick()

      // Selector helper optimizado
      const $ = (sel) => {
        const nodes = gsap.utils.toArray(sel);
        // console.log(`Selector '${sel}' encontró:`, nodes.length); // Debug opcional
        return Array.from(nodes).filter(Boolean);
      }

      const foto = $('.imagen-xv-wrapper')

      const flores = [
        '.flor-1',
        '.flor-2',
        '.flor-3',
        '.flor-4',
        '.flor-5',
        '.flor-6'
      ].flatMap($)

      /* 🔥 ORDEN EXACTO DEL TEMPLATE INCLUYENDO EL AMPERSAND */
      const textoSelectors = [
        '.frase-bendicion',                    // 1. Con la bendición...
        // Seleccionamos los hijos directos del contenedor de nombres para animar en orden: 
        // Marine -> & -> Cesar
        '.nombres-contenedor > *',             
        '.separador-elegante',                // 3. Separador
        '.parrafo-presentacion'               // 4. Párrafo final
      ];

      // Si tienes selectores condicionales (como .padrinos-label que no están en el template provisto)
      // asegúrate de que existen o añádelos con cuidado. Usaré solo los presentes en el HTML dado.
      const texto = textoSelectors.flatMap($);

      // Estado inicial: ocultos y desplazados hacia abajo
      gsap.set([...foto, ...flores, ...texto], { autoAlpha: 0, y: 28 })

      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return

          const tl = gsap.timeline({ defaults: { ease: 'power2.out' } })

          // 1. Animación de la Foto
          tl.fromTo(
            foto,
            { scale: 0.94, y: 40, filter: 'blur(6px)' },
            { autoAlpha: 1, scale: 1, y: 0, filter: 'blur(0px)', duration: 1.15 }
          )

          // 2. Entrada de Flores (staggered)
          tl.to(
            flores,
            {
              autoAlpha: 1,
              y: 0,
              rotate: () => gsap.utils.random(-8, 6),
              duration: 0.9,
              stagger: 0.12
            },
            '-=0.6' // Solapamiento con la foto
          )

          /* 🔥 ANIMACIÓN RESPETANDO ORDEN VISUAL DEL TEXTO */
          // Esto animará: Frase -> Marine -> & -> Cesar -> Separador -> Párrafo
          tl.to(
            texto,
            {
              autoAlpha: 1,
              y: 0,
              duration: 0.8,
              stagger: 0.18 // Tiempo entre la entrada de cada elemento
            },
            '-=0.3' // Solapamiento con las flores
          )

          // --- Animaciones Infinitas (Flote y Escala) ---

          flores.forEach((flor, i) => {
            gsap.to(flor, {
              y: `+=${gsap.utils.random(6, 14)}`,
              x: `+=${gsap.utils.random(-6, 6)}`,
              rotation: gsap.utils.random(-0.8, 0.8),
              duration: gsap.utils.random(2.8, 4),
              repeat: -1,
              yoyo: true,
              ease: 'sine.inOut',
              delay: i * 0.2
            })
          })

          gsap.to(foto, {
            scale: 1.015,
            duration: 3.5,
            yoyo: true,
            repeat: -1,
            ease: 'sine.inOut'
          })

          io.disconnect() // Dejar de observar una vez activada
        })
      }, { threshold: 0.45 }) // Se activa cuando el 45% es visible

      if (rootRef.value) io.observe(rootRef.value)
    })

    return { rootRef }
  }
}
</script>

<style scoped>
.padrinos-label{
  font-family: "Playfair Display", serif;
  font-size: clamp(18px, 2.6vw, 24px);
  color:#2f2e2e;
  margin-top: 12px;
}

.padrino-nombre{
  font-family: "titulos", cursive;
  font-size: 40px;
  color:#e6b1c4;
  margin: 4px 0;
}
</style>

<style scoped>
.flor-4{
  top: 80px;
  left: 0px;
  transform: translateX(-50%) rotate(-12deg);
  width: min(40vw, 200px);
  z-index: -6 !important;
}
.flor-5{
  bottom: 20px;
  transform: translateX(-50%) rotate(-12deg);
  opacity: 0 !important;
  right: 0px;
  width: min(46vw, 240px);
  z-index: -8 !important;
}
.flor-6{
  top: 420px;
  transform: translateX(-50%) rotate(-12deg);
  right: -150px;
  width: min(34vw, 180px) !important;
  z-index: 3;
}
</style>

<style scoped>
.portada-xv{
  position:relative;
  width:100%;
  min-height:100vh;
background: 
    linear-gradient(
      180deg, 
      rgba(30, 29, 29, 0.037) 0%, 
      rgba(56, 55, 55, 0.75) 50%, 
      rgba(30, 29, 29, 0.90) 100%
    ),
    url('@/assets/868c37639dbb1146bf6f15e33b78a641.jpg') center/cover no-repeat;  overflow:visible;
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:flex-start;
  padding:48px 16px 56px;
}

/* Marco con recorte superior redondeado corregido */
.imagen-xv-wrapper{
  width: min(85vw, 320px);
  aspect-ratio: 2 / 3;
  max-height: 55vh;
  margin-top: 6px;
  border-radius: 180px 180px 0 0;
  overflow: hidden;
  z-index: 2;
  background:#fff;
  box-shadow:
    0 12px 40px rgba(0,0,0,.18),
    0 2px 8px rgba(0,0,0,.06);
  will-change: transform, filter, opacity;
}
.imagen-xv{
  width:100%;
  height:100%;
  object-fit:cover;
  display:block;
}

/* Texto */
.texto-xv{
  max-width: 620px;
  text-align:center;
  margin-top: 22px;
  padding: 0 8px;
}
.frase-bendicion{
  font-family: "Playfair Display", serif;
  font-size: clamp(18px, 2.6vw, 24px);
  color:#f4f3f3;
  line-height:1.5;
  margin: 20px 0 10px;
}
.separador-elegante{
  width:110px;
  height:2px;
  margin:12px auto 16px;
  background: linear-gradient(90deg, transparent, #d9b7c6, transparent);
  border-radius: 2px;
}
.nombre-protagonista{
  font-family: "british", cursive;
  font-size: 32px;
  color:#e6b1c4;
  margin: 0 0 8px 0;
  line-height:1.1;
}
.parrafo-presentacion{
  font-family: "quote", sans-serif;
  font-size: clamp(16px, 2.6vw, 16px);
  color:#f4f3f3;
  line-height:1.7;
  margin-top: 6px;
}

/* FLORES */
.flor{
  position:absolute;
  width:min(44vw, 240px);
  z-index:10;
  transform-origin:center;
  will-change: transform, opacity;
}
.flor-1{ top:-10px; left:-110px; z-index:-5 !important; }
.flor-2{ top:60px; right:-80px; transform: rotate(-80deg); z-index:1; width:min(40vw, 220px) !important; opacity:0 !important; }
.flor-3{ bottom:-80px; left:-120px; transform: rotate(-30deg); z-index:-9 !important;}

/* BOLA DISCO */
.bola{
  position:absolute;
  width:0px;
  animation: girar 10s linear infinite;
  opacity:.85;
  z-index:1;
  opacity:0 !important;
  will-change: transform;
}
.bola-izquierda{ left:-20px; bottom:-50px; z-index:-9 !important;}
@keyframes girar{ from{transform:rotate(0)} to{transform:rotate(360deg)} }

/* Responsive refinado */
@media (min-width: 992px){
  .portada-xv{ padding-top:64px; }
  .imagen-xv-wrapper{ margin-top: 0; }
}/* Si usas la Opción 2 con el <span> para el ampersand */
.ampersand {
  font-family: 'Cormorant Garamond', serif;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0, "clig" 0, "dlig" 0;
  font-style: normal; /* Si está en italic suele cambiar la forma del ampersand */
  font-size: 2rem;
  color: #e6b1c4;
  margin: 0 10px;
  display: inline-block;
  vertical-align: middle;
}
</style>